<section class="form-field-container">
  <article class="form-field-container__actions gt-xs:pr-3">
    @if (isFieldReadonly) {
      <div class="readonly-icon">
        <ts-icon [matTooltip]="'Read-only field'" [icon]="'ts_lock-alt'" [color]="'gray'"></ts-icon>
      </div>
    }
    @if (!!showTip) {
      <div class="tooltip-icon">
        <ts-icon [matTooltip]="tooltipContent" [icon]="'info'" [color]="'gray'"></ts-icon>
      </div>
    }
    @if (canShowHistory) {
      <div class="history-panel-icon cursor-pointer" #historyPanelOrigin>
        <ts-icon [icon]="'history'" [color]="'gray'" (click)="openHistoryPanel()"></ts-icon>
      </div>
    }
  </article>

  <ng-template form-field-host></ng-template>
</section>
<ng-template #historyPanel>
  <div class="history-overlay">
    <div class="history">
      <app-field-history [model]="model" [fieldDef]="fieldDef" [data]="data"></app-field-history>
    </div>
  </div>
</ng-template>
